/** @jsx jsx */
import React, { Fragment, useRef } from 'react'
import { Box, Heading, jsx } from 'theme-ui'

import { graphql } from 'gatsby'

import Container from '../components/Container'
// import Heading from '../components/Typography/Heading/Heading'
const { parseStars } = require('../utils/parseStars')

import SEO from '../components/SEO'

import { GenerateBlock } from './generateBlocks'
import { parseVariantsFromTags } from '../utils/parseTags'
import ProductList from '../components/blocks/ProductList'
import ReviewBlock from '../components/product/ReviewBlock'

import { useEffect, useState } from 'react'
import { useGetLiveProduct } from '../hooks/queries'
import { Global } from '@emotion/core'
import { slickStyles } from '../components/shared/Carousel/ProductImageCarousel'
import { getAverage } from '../utils/getAverage'
import Hero from '../components/blocks/Hero'
import { sum } from '../utils'
import { useWindowSize } from '../hooks/useWindowSize'

const productRelatedTitles = ['TOP PICKS FOR YOU', 'UPGRADE TO A BUNDLE + SAVE']

const mapReview = revs =>
  revs.map(c => ({
    ...c,
    reply:
      (c.firstCompanyComment && c.firstCompanyComment.comment) ||
      (c.companyReply && c.companyReply.text),
    commentSubmissionDate: c.createdAt,
    commentTitle: c.content || c.title,
    commentText: c.text || c.review,
    clientName: (c.consumer && c.consumer.displayName) || c.personName,
    stars: parseStars(c.stars),
  }))

const ProductTemplate = ({ data }) => {
  const myRef = useRef(null)
  const { mobile } = useWindowSize()
  const executeScroll = () => {
    myRef.current.scrollIntoView({ behavior: 'smooth', alignToTop: true })
  }

  const [currentProduct, setCurrentProduct] = useState({})
  const {
    description,
    title,

    shopifyId,
    tags,
    relatedCollection,
    chainReviews = [],
    ringReviews = [],
    braceletReviews = [],
    images,
    primaryTag,
    secondaryTag,
    details,
    trustPilotProductReviews = [],
    productPageContent,
  } = data.shopifyProduct

  const { data: liveProduct, loading, error, refetch } = useGetLiveProduct({
    id: shopifyId,
  })

  useEffect(() => {
    if (liveProduct) {
      setCurrentProduct(liveProduct.node)
    }
  }, [liveProduct])

  const businessReviewSummary = data.trustPilotPublicBusinessUnit
  let reviews = trustPilotProductReviews.concat(
    ringReviews,
    braceletReviews,
    chainReviews
  )

  const numberOfBusinessReviews = details.hideTpServiceReviews
    ? 0
    : sum(businessReviewSummary.numberOfReviews)

  // const businessReviewAvg = numberOfBusinessReviews /

  const { blocks } = data.contentfulProductPage

  const openGraphImage =
    images &&
    images[0].localFile &&
    images[0].localFile.childImageSharp &&
    images[0].localFile.childImageSharp.fluid.src

  const avgScore = getAverage(reviews, 'stars')

  const productListHasAvailableProducts =
    relatedCollection &&
    relatedCollection.products.find(i => i.availableForSale)

  const productVideoUrl = details && details.productVideo

  return (
    <Fragment>
      <Global styles={slickStyles} />
      <SEO
        title={details.seoTitle || title}
        description={
          details.seoDescription || details.description || description
        }
        image={openGraphImage}
      />
      {blocks.map((i, k) => (
        <GenerateBlock
          key={k}
          {...{
            block: {
              ...i,
              ...data.shopifyProduct,
              ...parseVariantsFromTags(tags),
              liveProduct: currentProduct,
              loading,
              avgScore,
              numberOfBusinessReviews: reviews.length + numberOfBusinessReviews,
              executeScroll,
              ref: myRef,
            },
            containerProps: {
              sx: {
                p: 30,
              },
            },
          }}
        />
      ))}
      {productVideoUrl && mobile && (
        <Box sx={{ mt: 25 }}>
          <Hero backgroundVideoUrl={productVideoUrl} inline={true} />
        </Box>
      )}
      {productPageContent &&
        productPageContent.blocks &&
        productPageContent.blocks.map((i, k) => (
          <GenerateBlock key={k} block={i} />
        ))}

      {productListHasAvailableProducts && (
        <Box sx={{ mt: '6em' }}>
          <ProductList
            carouselMode={true}
            collection={relatedCollection}
            showTitle={true}
            title={
              relatedCollection.title.startsWith('Upgrade')
                ? productRelatedTitles[1]
                : productRelatedTitles[0]
            }
          />
        </Box>
      )}
      {reviews.length > 0 && (
        <Container sx={{ mt: 25 }}>
          <Box sx={{ margin: 'auto' }}>
            <ReviewBlock
              ref={myRef}
              extraPage={true}
              psuedoReviewCounts={
                !details.hideTpServiceReviews &&
                businessReviewSummary.numberOfReviews
              }
              productName={data.shopifyProduct.title}
              reviewImages={null}
              {...{
                avgReviewScore: avgScore || 'No Reviews',
                numOfReviews: reviews.length + numberOfBusinessReviews,
                tabTitles: ['Reviews', 'Questions'],
                showForms: true,
                showNumOfComments: 5,
                comments: mapReview(reviews),
                questions: reviews
                  .filter(i => i.question && i.answer)
                  .map(c => ({
                    commentSubmissionDate: '10/28/19',
                    commentTitle: c.question,
                    reply: c.answer,
                    clientName: c.questionPersonName,
                  })),
              }}
            />
          </Box>
        </Container>
      )}
      {/* {trustPilotSkus.length > 0 && (
        <Container sx={{ mt: 25 }}>
          <TrustPilot
            sx={{ mx: [35, null, null, null, null, 0] }}
            class="trustpilot-widget"
            data-locale="en-US"
            data-template-id="5717796816f630043868e2e8"
            data-businessunit-id="5ee82db4edf1fe0001effc87"
            data-style-height="600px"
            data-style-width="100%"
            data-theme="light"
            data-sku={`${trustPilotSkus.join(',')}`}
            data-review-languages="en"
            data-reviewnumber="2"
          />
        </Container>
      )} */}
    </Fragment>
  )
}

export const query = graphql`
  query Product($shopifyId: String!) {
    contentfulReviewImageGrid {
      images {
        fluid(maxWidth: 800) {
          ...GatsbyContentfulFluid_withWebp_noBase64
        }
      }
    }
    trustPilotPublicBusinessUnit {
      id
      numberOfReviews {
        threeStars
        fourStars
        fiveStars
      }
      score {
        stars
      }
    }
    shopifyProduct(shopifyId: { eq: $shopifyId }) {
      ...ShopifyProductPageDetails
    }
    contentfulProductPage {
      title
      blocks {
        __typename
        ... on ContentfulProductHeroComponent {
          accordion {
            accordionSteps {
              value
              description {
                raw
              }
            }
          }
          companyValueTags {
            value
          }
          companyValueTextSection {
            value
            icon {
              file {
                url
              }
            }
          }
        }
      }
    }
  }
`

export default ProductTemplate
